import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'
import React from 'react'
import { useMediaQuery } from '@mantine/hooks'
import styles from './kdt-python-16th.module.scss'

interface IBenefitAccordionProps {
  contents: {
    title: string
    descList: string[]
  }
  idx: number
}

const BenefitAccordion = ({ contents, idx }: IBenefitAccordionProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const defaultOpen = idx === 0
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const onOpenHandler = useCallback(() => {
    if (isMobile) {
      setIsOpen(!isOpen)
    }
  }, [isOpen, isMobile])

  return (
    <li
      className="group mb-4 list-none overflow-hidden last-of-type:mb-0 lg:mb-6"
      onClick={onOpenHandler}
    >
      <div className="cursor-pointer lg:cursor-default">
        <div className="flex flex-row items-center gap-5">
          <div
            className={`${
              isOpen || !isMobile ? 'rounded-t-lg py-3 lg:pb-5 lg:pt-7' : 'rounded-lg py-3 lg:py-7'
            } flex w-full items-center justify-between gap-x-3 bg-trueGray-800 px-4 lg:px-6`}
          >
            <div className="flex flex-row items-center gap-2 lg:gap-3.5">
              <img
                className="hidden h-[34px] w-6 object-contain lg:inline-block"
                src={
                  'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section10_icon1.png'
                }
                alt="-"
              />
              <p
                className={`${
                  isOpen || !isMobile ? 'text-white' : 'text-label-assistive'
                } whitespace-pre-line text-lg font-bold leading-normal lg:text-2xl`}
              >
                {contents.title}
              </p>
            </div>
            {isMobile && (
              <ChevronDownIcon
                className={`${
                  isOpen ? 'rotate-180 transform text-white' : 'text-label-assistive'
                } ml-auto h-auto w-4 shrink-0 grow-0`}
              />
            )}
          </div>
        </div>
      </div>
      {(isOpen || !isMobile) && (
        <div className="flex w-full rounded-b-lg bg-trueGray-800 px-4 pb-4 lg:px-6 lg:pb-7">
          <div className="flex flex-1 flex-col rounded bg-[#1F1F1F] px-4 py-3 lg:bg-inherit lg:px-0 lg:py-0">
            <ul className="flex flex-col lg:mt-5">
              {contents.descList.map(desc => (
                <li
                  key={desc}
                  className="border-b border-[#2E2E2E] py-2 first-of-type:pt-0 last-of-type:border-b-0 last-of-type:pb-0 lg:border-[#404040] lg:py-4"
                >
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section10} whitespace-pre-line text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    {desc}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </li>
  )
}

export default BenefitAccordion
